module.exports = __webpack_public_path__ + "static/img/sustainability_ttl.62bfab8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/sustainability_ttl.svg
// module id = YkwP
// module chunks = 0